export var ROUTE_SEGMENTS = {
    HOME: '/',
    SHOP: 'shop',
    CAFETERIA_BENEFITS: 'cafeteria-benefits',
    INCOME_TEAL: 'income-teal',
    PROFILE: 'profile',
    SETTINGS_PROFILE: 'settings-profile',
    ADDRESS_BOOK: 'address-book',
    ADDRESS_BOOK_EMPLOYEE: 'address-book/:userId',
    ORGANIZATION_STRUCTURE: 'organization-structure',
    TAKE_SURVEY: 'take-survey/:surveyId',
    MY_DEVELOPMENT: 'my-development',
    MY_EMPLOYEES_DEVELOPMENT: 'my-employees-development',
    AWARDS: 'awards',
    AWARD: 'award/:awardId',
    RATINGS: 'ratings',
    SURPRISE_BOXES: 'surprise-boxes',
    SURPRISE_BOX: 'surprise-boxes/:id',
    CREATE_ONE_TO_ONE: 'create-one-to-one',
    EDIT_ONE_TO_ONE: 'edit-one-to-one/:id',
    POST: 'post/:postId',
    AWARD_POST: 'award-post/:postId',
    ACTIVITY_ANNOUNCEMENT_POST: 'activity-announcement-post/:postId',
    LEADER_POST: 'leader-post/:postId',
    BIRTHDAY_POST: 'birthday-post/:postId',
    RECOGNITION_POST: 'recognition-post/:recognitionPostId',
    RECOGNITION_SUPERVISOR_POST: 'recognition-supervisor-post/:recognitionPostId',
    SURVEY_POST: 'survey-post/:postId',
    CHATS: 'chats',
    CHAT: 'chat/:chatId',
    SUPERVISOR_APPLICATIONS: 'supervisor-applications',
    EMPLOYEES: 'employees',
    EDIT_EMPLOYEE: 'edit/employee/:userId',
    APPLICATIONS: 'applications',
    SETTINGS: 'settings',
    CREATE_EMISSION: 'create-emission',
    EDIT_EMISSION: 'edit-emission/:emissionId',
    ORDERS: 'orders',
    ACTIVITIES: 'activities',
    PRODUCTS: 'products',
    CREATE_PRODUCT: 'create-product',
    EDIT_PRODUCT: 'edit-product/:productId',
    EDIT_CAFETERIA_BENEFITS: 'edit-cafeteria-benefits/:benefitId',
    CREATE_AWARD: 'create-award',
    SURPRISE_BOXES_CREATE: 'surprise-boxes/create',
    SURPRISE_BOXES_EDIT: 'surprise-boxes/edit/:id',
    EDIT_AWARD: 'edit-award/:awardId',
    SURVEYS: 'surveys',
    SELECT_SURVEY_TYPE: 'select-survey-type',
    CREATE_SURVEY: 'create-survey',
    EDIT_SURVEY: 'edit-survey/:surveyId',
    SURVEY_RESULTS: 'survey-results/:surveyId',
    ENPS_SURVEY_RESULTS: 'enps-survey-results/:surveyId',
    SUPPORT_REQUESTS: 'support-requests',
    SUPPORT_REQUEST: 'support-request/:requestId',
    STATISTICS: 'statistics',
    TEAM_STATISTICS: 'team-statistics',
    CORPORATE_CURRENCY_STATISTICS: 'corporate-currency-statistics',
    ACTIVITIES_STATISTICS: 'activities-statistics',
    SURVEYS_STATISTICS: 'surveys-statistics',
    REWARDS_STATISTICS: 'rewards-statistics',
    GRATITUDES_STATISTICS: 'gratitudes-statistics',
    POST_CREATE: 'post/create',
    POST_EDIT: 'post/edit/:postId',
    USERS: 'users',
    BENEFIT_ADMIN: 'benefit-admin',
    REGISTRATION: 'registration',
    REGISTRATION_COMPANY: 'registration/:companyId',
    HR_CLUB_REGISTRATION: 'hr-club-registration/:companyId',
    TAKE_SURVEY_LINK_ACCESS: 'take-survey/link-access/:surveyId',
    PREVIEW_SURVEY: 'preview-survey',
    DOCS: 'docs',
    CONFIDENTIAL: 'confidential',
    COOKIES: 'cookies',
    POLICY: 'policy',
    COMPLIANCE: 'compliance',
};
